module.exports = "/_next/static/images/da895dfd2d8a684dadcea15c21bb4e63-nu-card-lg@1x.jpg.webp";